import React, { useEffect, useState } from "react";
import DimondImg from "../../../asset/new/images/icons/diamond.svg";
import { GetPackage } from "../../../Redux/Slices/Package";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FaCheck, FaPhone, FaEnvelope, FaCrown } from "react-icons/fa";
import "../../../asset/new/css/employer-modern.css";

const YesNoModal = ({ show, handleClose, handleYes }) => {
  if (!show) return null;

  return (
    <div className="employer-modal-overlay" onClick={handleClose}>
      <div className="employer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="employer-modal-header">
          <h3>Confirm Purchase</h3>
          <button className="employer-modal-close" onClick={handleClose}>×</button>
        </div>
        <div className="employer-modal-body">
          <p>Do you want to proceed with this package purchase?</p>
        </div>
        <div className="employer-modal-footer">
          <button className="employer-btn employer-btn-secondary" onClick={handleClose}>
            Cancel
          </button>
          <button className="employer-btn employer-btn-primary" onClick={handleYes}>
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

const PackageCard = () => {
  const [packageDetails, setPackageDetails] = useState({});
  const [packageId, setPackageId] = useState("");
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  const packageData = async () => {
    try {
      let data = await GetPackage();
      setPackageDetails(data);
    } catch (error) {
      console.error("Error fetching package data:", error);
    }
  };

  const [showModal, setShowModal] = useState(false);

  const confirmationHandler = (id) => {
    setShowModal(true);
    setPackageId(id);
  };

  const handleYes = () => {
    setShowModal(false);
    navigate(`/employer/payment/${packageId}`);
  };

  const handleClose = () => {
    setShowModal(false);
    setPackageId("");
  };

  const handleBuyNow = (id) => {
    if (role === "Employer") {
      confirmationHandler(id);
      return;
    }

    toast.error("Login as Recruiter to Buy");
    navigate("/signin", {
      state: {
        from: "/recruiter",
      },
    });
  };

  useEffect(() => {
    packageData();
  }, []);

  return (
    <div>
      <div className="employer-page-header" style={{ marginBottom: '2rem' }}>
        <h2 className="employer-page-title">Our Packages</h2>
        <p style={{ color: 'var(--employer-text-muted)', marginTop: '0.5rem' }}>
          Choose the package that best fits your hiring needs
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {packageDetails?.docs
          ?.filter((item) => item?.is_active === true)
          .map((value, index) => (
            <div key={index} className="employer-card" style={{ 
              transition: 'transform 0.2s, box-shadow 0.2s',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '';
            }}>
              <div className="employer-card-body" style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%',
                padding: '2rem 1.5rem'
              }}>
                <div style={{ textAlign: 'center', flex: 1 }}>
                  <h3 style={{ 
                    fontSize: '1.25rem', 
                    fontWeight: 600, 
                    color: 'var(--employer-text-primary)',
                    marginBottom: '1rem'
                  }}>
                    {value?.name}
                  </h3>
                  
                  <p style={{ 
                    color: 'var(--employer-text-muted)', 
                    fontSize: '0.875rem',
                    marginBottom: '1rem',
                    minHeight: '40px'
                  }}>
                    {value?.offer}
                  </p>

                  <div style={{ 
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.5rem 1rem',
                    background: 'var(--employer-bg-secondary)',
                    borderRadius: '8px',
                    marginBottom: '1.5rem',
                    fontSize: '0.875rem',
                    color: 'var(--employer-text-secondary)'
                  }}>
                    <FaCheck style={{ color: 'var(--employer-success)' }} />
                    Validity: <strong>{value?.validity_day} Days</strong>
                  </div>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <div style={{ 
                      fontSize: '2.5rem', 
                      fontWeight: 700, 
                      color: 'var(--employer-primary)',
                      lineHeight: 1
                    }}>
                      ₹{value?.cost}
                    </div>
                  </div>
                </div>

                <button
                  className="employer-btn employer-btn-primary"
                  onClick={() => handleBuyNow(value?._id)}
                  style={{ width: '100%' }}
                >
                  Buy Now
                </button>
              </div>
            </div>
          ))}

        {/* Premium Pack Card */}
        <div className="employer-card" style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          transition: 'transform 0.2s, box-shadow 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 12px 24px rgba(102, 126, 234, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '';
        }}>
          <div className="employer-card-body" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: '2rem 1.5rem'
          }}>
            <div style={{ 
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '50%',
              padding: '1rem',
              marginBottom: '1rem'
            }}>
              <FaCrown style={{ fontSize: '2rem' }} />
            </div>
            
            <h3 style={{ 
              fontSize: '1.5rem', 
              fontWeight: 700,
              marginBottom: '1rem'
            }}>
              Premium Pack
            </h3>
            
            <p style={{ 
              fontSize: '0.95rem',
              opacity: 0.9,
              marginBottom: '2rem',
              lineHeight: 1.6
            }}>
              Get Unlimited CV access and job posting
            </p>

            <div style={{ 
              width: '100%',
              padding: '1.5rem',
              background: 'rgba(255, 255, 255, 0.15)',
              borderRadius: '12px',
              backdropFilter: 'blur(10px)',
              marginBottom: '1rem'
            }}>
              <div style={{ marginBottom: '1rem' }}>
                <a
                  href="tel:+91-9088026253"
                  style={{ 
                    color: 'white',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    fontSize: '1rem',
                    fontWeight: 500
                  }}
                >
                  <FaPhone style={{ fontSize: '0.875rem' }} />
                  +91-90880 26253
                </a>
              </div>
              
              <div>
                <a
                  href="mailto:sonia@cajobportal.com"
                  style={{ 
                    color: 'white',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    fontSize: '0.95rem',
                    fontWeight: 500
                  }}
                >
                  <FaEnvelope style={{ fontSize: '0.875rem' }} />
                  sonia@cajobportal.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Yes/No Modal */}
      <YesNoModal
        show={showModal}
        handleClose={handleClose}
        handleYes={handleYes}
      />
    </div>
  );
};

export default PackageCard;
